/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from 'react';
import api from '../services/Api';

import Translate from '../i18n/Translate';
import PromotionsLoader from './loaders/PromotionsLoader';
import PromotionsItems from './PromotionsItems';

const Promotions = () => {
  const [promotions, setPromotions] = useState({
    loading: false,
    data: {
      status: true,
      result: [],
      message: '',
    },
    error: null,
  });

  const getData = async () => {
    setPromotions({
      ...promotions,
      loading: true,
      error: null,
    });

    try {
      const data = await api.images.promotions();
      setPromotions({
        loading: false,
        data,
      });
    } catch (error) {
      setPromotions({
        loading: false,
        error: error.message,
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (promotions.loading === true) {
    return <PromotionsLoader />;
  }

  return (
    <>
      {promotions.data.result?.length ? (
        <section className='promotions'>
          <div className='promotions__container'>
            <div>
              <h3 className='promotions__title'>
                <Translate langkey='promotions.title' />
              </h3>

              <p className='promotions__subtitle'>
                <Translate langkey='promotions.subtitle' />
              </p>
            </div>

            <div className='promotions__cards'>
              {promotions.data.result?.map((promotion) => {
                return <PromotionsItems key={promotion.id} promotion={promotion} />;
              })}
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
};

export default Promotions;
